module.exports = "../images/fishing-hero@2x.jpg?v=0fad14d";